import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

function OrDivider() {
  return (
    <Container>
      <Box component="span">OR</Box>
    </Container>
  );
}

const Container = styled(Box, { label: 'Container' })(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 18,
  marginBottom: 18,
  '& > span': {
    display: 'inline-flex',
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: 500,
    letterSpacing: '0.25px',
    color: theme.palette.custom.body,
    background: theme.palette.custom.white,
    position: 'relative',
    zIndex: 1,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: 1,
    background: theme.palette.custom.line,
    top: '50%',
    left: 0,
  },
}));

export default OrDivider;
